import { IWorkflowRepository } from "domain/contracts/workflow.contract";
import { Workflow } from "domain/entities/workflow";
import { WorkflowInputFilter } from "domain/models/workflow-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";

class WorkflowRepository implements IWorkflowRepository {
  async getAllToApproval(
    filter: WorkflowInputFilter
  ): Promise<Message<Workflow[]>> {
    const response = await httpClient.get(`/workflows/tasksToApproval`, {
      params: filter,
    });
    return response.data;
  }
}

export default new WorkflowRepository();
